import { useMemo } from 'react';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';

/**
 * Whether this visitor is enrolled in the hardware-first checkout experiment. The
 * 'hardware-first-checkout' feature is string-valued: a non-empty value names the hardware
 * price set the server resolves; empty or absent means control. The client never reads the
 * set name - all pricing comes from the server.
 */
export default function useHardwareFirstCheckout(): boolean {
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  return useMemo(() => {
    if (!isGrowthBookEnabled) {
      return false;
    }
    // typeof guard: a forced-override cookie can coerce to a boolean or number
    const priceSetName = getFiGrowthBook().getFeatureValue<string>('hardware-first-checkout', '');
    return typeof priceSetName === 'string' && priceSetName.length > 0;
  }, [isGrowthBookEnabled]);
}
